import React, { FunctionComponent } from "react";

const data = [
    {
      name: "Bindu Moochikkal",
      mobile: "+916802514798",
      mail: "bindu.ma2@gmail.com",
      city: "Cuddalore",
      view: "..."
    },
    {
      name: "Lakshmi Sree",
      mobile: "+917802937403",
      mail: "sree89@gmail.com",
      city: "Villupuram",
      view:"..."
    },
    { 
        name: "Anandha Jothi", 
        mobile: "+919857092780", 
        mail: "anandhajo@gmail.com", 
        city: "Chennai",
        view:"..." 
    },
    { 
        name: "Latha Dhanush", 
        mobile: "+918870127913", 
        mail: "latharenu555@gmail.com", 
        city: "Chennai",
        view:"..." 
    },   
    {
      name: "Bindu Moochikkal",
      mobile: "+916802514798",
      mail: "bindu.ma2@gmail.com",
      city: "Cuddalore",
      view: "..."
    },
    {
      name: "Lakshmi Sree",
      mobile: "+917802937403",
      mail: "sree89@gmail.com",
      city: "Villupuram",
      view:"..."
    },
    { 
        name: "Anandha Jothi", 
        mobile: "+919857092780", 
        mail: "anandhajo@gmail.com", 
        city: "Chennai",
        view:"..." 
    },
    { 
        name: "Latha Dhanush", 
        mobile: "+918870127913", 
        mail: "latharenu555@gmail.com", 
        city: "Chennai",
        view:"..." 
    }, 
  ];

  export default function Contact() {
    return (   
        <div className="custom-table mt-3">
          <table>
            <thead>
              <tr >
                <th>User Name</th>
                <th>Mobile Number</th>
                <th>Email Id</th>
                <th>City</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data.map((value, key) => {
                return (
                  <tr className="TableRow" key={key}>
                    <td>{value.name}</td>
                    <td>{value.mobile}</td>
                    <td>{value.mail}</td>
                    <td>{value.city}</td>
                    <td>{value.view}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
    );
}
  